export default __webpack_public_path__ + "static/media/prana02b.6d62e136.JPG";